import { Assets } from 'vue'

export function useAssetPreload() {
    //#region  Assets
    const imgSrc: Assets[] = [
        {
            name: 'bear_8',
            type: 'image',
            src: require('@/assets/imgs/bear_8.png')
        },
        {
            name: 'big_tiger',
            type: 'image',
            src: require('@/assets/imgs/big_tiger.png')
        },
        {
            name: 'dragon_7',
            type: 'image',
            src: require('@/assets/imgs/dragon_7.png')
        },
        {
            name: 'small_tiger',
            type: 'image',
            src: require('@/assets/imgs/small_tiger.png')
        },
        {
            name: 'card_109A',
            type: 'image',
            src: require('/public/images/cards/109A.png')
        },
        {
            name: 'popup_bg',
            type: 'image',
            // src: require('@/assets/imgs/pop.png')
            src: require('@/assets/imgs/pop.jpeg')
        },
        {
            name: 'button',
            type: 'image',
            src: require('@/assets/imgs/button.png')
        }
    ]
    //#endregion

    const assets = [...imgSrc]

    const LoadAssest = (_assets: Assets) => {
        return new Promise((resolve, reject) => {
            if (_assets.type === 'image') {
                const img = new Image()
                img.src = _assets.src
                img.onload = () => {
                    resolve(img)
                    // console.log(`Loaded asset: ${_assets.name}`)
                }

                img.onerror = img.onabort = () => {
                    reject(_assets)
                }
            }
        })
    }

    const PreloadAssets = async () => {
        // console.log('Preloading Assets...')
        assets.map(imgs => LoadAssest(imgs).catch(err => err))
    }

    return {
        PreloadAssets
    }
}
